import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { BsArrow90DegLeft } from "react-icons/bs";
import { BiRightArrowAlt } from "react-icons/bi";
import { BiLeftArrowAlt } from "react-icons/bi";
import React, { useEffect, useState } from "react";
import Heading from "../Highlightedheading/Heading";
import Button from "../Buttons/Button";
import RoundedShadow from "../../assets/Shortfilms/Group 1697.png";
import Rounded from "../../assets/Shortfilms/pexels-photo-102129.png";

import img1 from "../../assets/Shortfilms/1.png";
import img2 from "../../assets/Shortfilms/2.png";
import img3 from "../../assets/Shortfilms/3.png";
// import img4 from "../../assets/Shortfilms/4.png";
// import img5 from "../../assets/Shortfilms/5.png";
// import img6 from "../../assets/Shortfilms/6.png";
// import img7 from "../../assets/Shortfilms/7.png";
import SwiperSlider from "../SwiperSlider/SwiperSlider";
import { useNavigate } from "react-router-dom";
import { shortsAndDocData } from "../../data/data";
import { shortsanddocAssets } from "../../assets/shortsanddocumentaries";

const ShortFilms = () => {
  const navigate = useNavigate();

  const dummyData = [
    {
      id: 1,
      name: "Bitter Sweets",
      headingText: "Documentary",
      imageUrl: shortsanddocAssets.BitterSweet,
      releaseInfo: {
        year: "2022",
        season: "",
        languages: "7 Languages",
        rating: "U/A 16+",
      },
      description:
        "Bittersweets is a heartfelt exploration of love and loss based on true events set in the ghettos of Bombay and delves into the intricate layers of human relationships, aspirations, and bitter realities that often accompany life's sweet moments. It holds the distinction of being the first film to be shot live on location in the vibrant and bustling streets of Bhendi Bazaar, adding an authentic layer of depth and charm to its visual storytelling.",
      genres: ["Drama", "Thriller"],
      buttonText: "WATCH TRAILER",
      // videoId: 293940724,
      videoId: "9U4o1ltJm2s",
      starring: ["Pankaj Tripathi", "Taher Shabbir"],
    },
    {
      id: 2,
      name: "Retrospective Film on BV Doshi",
      headingText: "Documentary",
      imageUrl: shortsanddocAssets.BvDoshi,
      releaseInfo: {
        year: "2014",
        season: "",
        languages: "Unknown",
        rating: "Not Rated",
      },
      description:
        "This documentary explores the life and legacy of India's first Pritzker Prize-winning architect, Balkrishna Vithaldas Doshi, a storyteller of space, a philosopher of design, and a pioneer of sustainability. From his early collaborations with Le Corbusier and Louis Kahn to his groundbreaking projects like CEPT University and Aranya Housing, we witness how Doshi redefined architecture as an art of empathy.",
      genres: ["Documentary", "Architecture"],
      buttonText: "WATCH NOW",
      // videoId: 281262645,
      videoId: "yZ-GpA-zhXU",
    },
    {
      id: 3,
      name: "Right Forward",
      headingText: "Documentary",
      imageUrl: shortsanddocAssets.RightForward,
      releaseInfo: {
        year: "2015",
        season: "1 Season",
        languages: "5 Languages",
        rating: "U/A 13+",
      },
      description:
        "Right Forward is an inspiring documentary about young girls from Mumbai’s underserved communities who defy the odds through soccer. With support from NGO Magic Bus, they rise above adversity to represent India internationally, travelling to the U.S. to showcase their talent, forge connections, and prove that dreams have no boundaries.",
      genres: ["Documentary", "Nature"],
      buttonText: "WATCH NOW",
      videoId: "T78b2yngHFw",
    },
    {
      id: 5,
      name: "Shiksha Ka Suraj",
      headingText: "Music Video",
      imageUrl: shortsanddocAssets.ShikshaKaSuraj,
      releaseInfo: {
        year: "2012",
        season: "1 Episode",
        languages: "Hindi",
        rating: "U",
      },
      description:
        "Shiksha Ka Suraj is a celebrity-led music video promoting adult literacy in India. With stars like Shah Rukh Khan and lyrics by Javed Akhtar, it encourages learning as a path to empowerment and was hailed as the “Mile Sur Mera Tumhara of the millennium.”",
      genres: ["Music", "Literacy", "Social Impact"],
      buttonText: "WATCH NOW",
      videoId: "w0TPgfZpqps",
    },
    {
      id: 6,
      name: "Skoda Prize Film",
      headingText: "Branded Short Film",
      imageUrl: shortsanddocAssets.SkodaPrize,
      releaseInfo: {
        year: "2011",
        season: "1 Short",
        languages: "English",
        rating: "U",
      },
      description:
        "A branded short film created for The Škoda Prize for Contemporary Art 2011, this piece celebrates emerging voices in Indian contemporary art and captures the spirit of the award and its vision.",
      genres: ["Art", "Contemporary", "Documentary"],
      buttonText: "WATCH NOW",
      videoId: "MYPCfCmmTSc",
    },
    {
      id: 7,
      name: "The Last Dance",
      headingText: "Wildlife Documentary",
      imageUrl: shortsanddocAssets.TheLastDance,
      releaseInfo: {
        year: "2006",
        season: "1 Film",
        languages: "English",
        rating: "U/A 7+",
      },
      description:
        "Following the cruel reality of bear dancing in India, this documentary unveils the exploitation of sloth bears and the illegal trade that fuels it. Through undercover footage and moving rescues, it captures the fight to end this practice and restore dignity to a species long abused.",
      genres: ["Wildlife", "Activism", "Documentary"],
      buttonText: "WATCH NOW",
      videoId: "hUOIHKaC4nU",
    },
  ];

  const [content, setContent] = useState(dummyData[dummyData.length - 1]);
  // const images = [img1, img3, img3];
  const images = shortsAndDocData?.map((data) => data.background);

  function handleWatchButton(id) {
    navigate(`/watch/${id}`);
  }

  return (
    <section className="px-4 pt-[60px] md:px-[7.2vw] md:pt-[100px] 3xl:pt-[120px] md:pb-[50px] w-full h-full">
      <div className="flex items-center justify-between z-30 relative hidden">
        {/* <Heading headingText={content?.name} /> */}
        {/* <Button
          buttonText={"VIEW ALL"}
          onClick={() => navigate("/long-format")}
        /> */}
      </div>

      <div
        // data-aos="fade-up"
        className="flex tab:flex-row  flex-col-reverse items-center justify-center md:pl-[3vw] px-4 gap-8 tab:gap-y-[1.875vw]"
      >
        <div className=" absolute left-[-520px]">
          <img src="images/Ellipse 63.png" alt="" />
        </div>

        <div className="w-full flex flex-col items-start z-10">
          <h2 className="text-transparent bg-clip-text bg-text-gradient md:text-[4.69vw] text-[10.67vw] leading-[10vw] font-bebas_neue tracking-normal tab:leading-[4.33vw]  uppercase brightness-125">
            {content?.name}
          </h2>
          <div className="flex flex-wrap items-center space-x-2 md:space-x-4 text-white  font-semibold brightness-125 md:leading-[3.15vh] mt-3 tab:mt-[2.17vh] font-montserrat">
            <div className="flex items-center justify-center  opacity-100 brightness-125">
              <span className="text-16 tab:text-[1.25vw] font-semibold opacity-100">
                {content?.year}
              </span>
            </div>

            {/* {content?.releaseInfo?.season && (
              <div className="flex items-center justify-center space-x-2">
                <span className="w-2 h-2 rounded-full bg-white opacity-50"></span>
                <span className="md:text-[1.25vw] font-semibold opacity-100">
                  {content?.releaseInfo?.season}
                </span>
              </div>
            )} */}

            {/* <div className="flex items-center justify-center space-x-2">
              <span className="w-2 h-2 rounded-full bg-white  opacity-50 "></span>
              <span className="md:text-[1.25vw] font-semibold opacity-100">
                {content.releaseInfo.languages}
              </span>
            </div> */}

            {/* <span className="w-2 h-2 rounded-full bg-white  opacity-50"></span>
            <div className="flex items-center justify-center space-x-2  bg-[#36c31f69]  rounded-md px-2">
              <span className="text-white brightness-200 md:text-[1.25vw] opacity-100 font-semibold">
                {content?.releaseInfo?.rating}
              </span>
            </div> */}
          </div>

          <p className=" whitespace-pre-line tracking-normal font-montserrat text-16 tab:text-[1.25vw] text-white opacity-100 font-normal  mt-[20px] tab:mt-[4.11vh] tab:w-[30.55vw]">
            {content?.desc}
          </p>
          {/* <div className="flex items-center space-x-2 text-white md:text-[1.25vw] md:pt-[3.53vh] md:leading-[3.15vh] font-montserrat font-medium opacity-100 brightness-125">
            {content?.genres.map((genre, index) => (
              <React.Fragment key={index}>
                <span>{genre}</span>
                {index < content?.genres?.length - 1 && (
                  <div className="w-[2px] h-6 bg-white"></div>
                )}
              </React.Fragment>
            ))}
          </div> */}

          <div
            className="border-[1px] mt-[30px] md:mt-[4.16vh] tab:mx-0 w-fit border-white py-[2.27vw] px-[2.27vw] md:py-[0.6vw] md:px-[1vw] 3xl:py-[1.1vw] 3xl:px-[1.7vw] rounded-full lg:rounded-[3.40vw] relative overflow-hidden group"
            onClick={() => handleWatchButton(content?.videoId)}
          >
            <button className="flex items-center gap-x-3 text-white uppercase font-montserrat text-[3.73vw] leading-[0] md:text-[1.25vw] md:leading-[0] font-semibold opacity-100 relative z-10">
              Watch Trailer
              <div className="flex items-center justify-center bg-[#4AB66C] rounded-full p-[2px] transition-colors duration-300 ease-in-out group-hover:bg-white">
                <BiRightArrowAlt className="text-white w-[6.5vw] md:w-[2.60417vw] h-auto transition-transform duration-300 ease-in-out group-hover:text-[#22AD86] -rotate-45 group-hover:rotate-0" />
              </div>
            </button>
            <div className="absolute inset-0 bg-custom-vertical-gradient transform translate-x-full group-hover:translate-x-0 transition-transform duration-500 ease-in-out"></div>
          </div>
        </div>

        <div className="relative w-full  h-full flex items-center justify-center tab:p-[3.125vw] pt-4">
          <div className="flex items-center justify-center z-10 object-blur drop-shadow-2xl relative md:scale-150 scale-125">
            <img
              src={RoundedShadow}
              alt="shadow"
              className="w-full h-full object-cover"
            />
            <div className="absolute scale-75 z-20 ">
              <img
                src={Rounded}
                alt="shadow"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute z-40 flex items-center justify-center  scale-90 ">
              <SwiperSlider
                images={images}
                dummyData={shortsAndDocData}
                setContent={setContent}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShortFilms;
